module.exports = __webpack_public_path__ + "static/media/food.4b92367c.svg";